import {datadogRum} from '@datadog/browser-rum';

export const ASSAY_SCHEMA_STORE_READ_ACTION = 'assay_schema_store_read';

const reportedReads = new Set<string>();

/**
 * Reports the first read of each `AssayStore` getter by each consumer in a page load, so RUM can show the share
 * of page loads that depend on the global full assay schema load.
 *
 * The `SyncDefinitions` and `SampleGroupSchemaSyncer` consumers only keep stores in sync with the Apollo cache;
 * exclude them when measuring which page loads need the full list.
 */
export default function reportAssaySchemaStoreRead(
  reader: string,
  consumer: string | undefined,
  isLoaded: boolean
): void {
  const resolvedConsumer = consumer ?? 'unknown';
  const key = `${reader}:${resolvedConsumer}`;
  if (reportedReads.has(key)) {
    return;
  }
  reportedReads.add(key);
  datadogRum.addAction(ASSAY_SCHEMA_STORE_READ_ACTION, {reader, consumer: resolvedConsumer, isLoaded});
}

export function resetReportedAssaySchemaStoreReadsForTests(): void {
  reportedReads.clear();
}
